// extracted by mini-css-extract-plugin
export var container = "sponsors-module--container--3088e";
export var divider = "sponsors-module--divider--b3549";
export var sponsorsWrapper = "sponsors-module--sponsors-wrapper--fcbd0";
export var title = "sponsors-module--title--ca86e";